import { useState, useEffect, useMemo, useLayoutEffect, useRef } from 'react';
import MotionLayout from '../../general/framer-motion/MotionLayout';

const Index = ({
    page
}:any) => {
    const iframeName = 'tool-iframe';
    const formRef = useRef(null);
    useEffect(() => {
        if(page){
            handleManualSubmit();
        }
    }, []);


    // Manually trigger form submission
    const handleManualSubmit = () => {
        if (formRef.current) {
            formRef.current.requestSubmit(); // Trigger the form submit event
        }
    };
        
    const iframePage = ["/api/tool/research-video"]
    const isIframe = iframePage.includes(page);

    return (
        <MotionLayout>
            {
                (page && !isIframe)
                &&
                <div>
                    <form ref={formRef} method="post" action={page} >
                        {/* <label>
                            Name:
                            <input type="text" name="name"  />
                        </label>
                            <br />
                        <label>
                            Email:
                            <input type="email" name="email"  />
                        </label>
                            <br />
                        <button type="submit">Submit</button> */}
                    </form>
                    <button style={{
                        display: "none"
                    }} onClick={handleManualSubmit}>Trigger Form Submission</button>
                     {/* Iframe to receive the form submission */}
                    {/* <iframe
                        name={iframeName}
                       // style={{ display: 'none' }} // Hide iframe if you don't want it visible
                        title="Form Submission Iframe"
                    /> */}
                </div>

            }
            {
                (page && isIframe)
                &&
                <div className='d-flex justify-content-center pt-5'>
                  
                    <iframe 

                        src={page} 
                        title="" 
                        frameBorder="0" 
                        style={{
                            width:"100%",
                            maxWidth:"1000px",
                            height:"100vh",
                            maxHeight:"600px",
                            boxShadow: "rgb(38, 57, 77) 0px 20px 30px -10px"
                        }}
                        allowFullScreen 
                    />
                 
                </div>  
            }
           
        </MotionLayout>
    );
};

export default Index;




  
